import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingService } from 'axis-components/components/loading/loading.service';
import { GmdService } from '../../services/gmd.service';
import { GmdContactComponent } from '../gmd-contact/gmd-contact.component';
import { GmdLocationComponent } from '../gmd-location/gmd-location.component';

@Component({
  selector: 'app-gmd-edit',
  templateUrl: './gmd-edit.component.html',
  styleUrls: ['./gmd-edit.component.scss']
})
export class GmdEditComponent implements OnInit {
  public tab = 1;
  public company;
  public companyId = "";
  public locationId = "";
  public notificationMessage = "";
  public errornotificationMessage = "";
  public alertTimeOut: number = 5000;
  public locationCount;
  public contactCount;
  public locationForm: FormGroup;
  public contactForm: FormGroup;
  @ViewChild(GmdLocationComponent) locationComponent: GmdLocationComponent;
  @ViewChild(GmdContactComponent) contactComponent: GmdContactComponent;
  constructor(private gmdService: GmdService, private router: Router, public loadingService: LoadingService) {
   }

  ngOnInit(): void {
    this.companyId = sessionStorage.getItem('selectedCompanyId');
    this.locationId = sessionStorage.getItem('selectedLocationId');
    this.gmdService.locationCount.subscribe(data => this.locationCount = data);
    this.gmdService.contactCount.subscribe(data => this.contactCount = data);
    this.gmdService.notificationMessage.subscribe((obs)=>
    {
      if (obs && obs !== "") {
        this.notificationMessage = obs;
      }
    });
    this.gmdService.errorNotificationMessage.subscribe((obs)=> {
      if (obs && obs !== "") {
        this.errornotificationMessage = obs;
      }
    });
  }

  public onTabClick(tabnumber: number) {
    this.tab = tabnumber;
    this.notificationMessage = '';
    this.errornotificationMessage = '';
  }
  public save() {
    this.companyId = sessionStorage.getItem('selectedCompanyId');
    if (this.tab !== 3) {
      this.notificationMessage = '';
      this.tab += 1;
      this.loadingService.start();
      this.onTabClick(this.tab);
    }
    else if (this.tab === 3) {
      this.notificationMessage = '';
      this.onTabClick(this.tab);
    }
  }
  
}
